export default __webpack_public_path__ + "static/media/LeftAlignIcon.6d6f02e6.svg";